import React from 'react';
import { LAST_UPDATED, PRICE, PRICE_LIST } from '@nykaa/seo/constants';

import { PriceListProps } from '.';
import { Row, Wrapper } from './styled';
import { contentTypes, isToRenderContent } from '../helper';

const PriceList = ({ list, pageType }: PriceListProps) => {
  const { title, bestSellers, lastUpdated } = list || {};
  if (!isToRenderContent(pageType, contentTypes.PriceList)) {
    return null;
  }
  return (
    <>
      {title && title.length > 0 && (
        <Wrapper>
          <h2>{`${title} ${PRICE_LIST}`}</h2>
          <table>
            <caption>{`${title} ${PRICE_LIST} - Product names and prices as of ${lastUpdated}`}</caption>
            <thead>
              <Row>
                <td className="titleColumn">
                  <span className="heading name">{title}</span>
                </td>
                <td className="priceColumn">
                  <span className="heading">{PRICE}</span>
                </td>
              </Row>
            </thead>
            <tbody>
              {bestSellers &&
                bestSellers.map((product) => {
                  let { productUrl = '', productName, mrp, inStock } = product;
                  let modifiedProductUrl = productUrl.replace(
                    'id',
                    'productId'
                  );
                  if (!inStock) {
                    return null;
                  }
                  return (
                    <Row key={`priceList_${productName}`}>
                      <td className="titleColumn">
                        <a href={modifiedProductUrl}>
                          <span>{productName}</span>
                        </a>
                      </td>
                      <td className="priceColumn">
                        <span>&#8377;{mrp}</span>
                      </td>
                    </Row>
                  );
                })}
              <Row className="last-update">{`${LAST_UPDATED}${lastUpdated}`}</Row>
            </tbody>
          </table>
        </Wrapper>
      )}
    </>
  );
};

export default PriceList;
